import { render, staticRenderFns } from "./CabinConfigInactive.vue?vue&type=template&id=3abb4bd1"
import script from "./CabinConfigInactive.vue?vue&type=script&lang=js"
export * from "./CabinConfigInactive.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports